import { Component, OnInit } from "@angular/core";
import { ModalController, NavController, NavParams, ToastController } from '@ionic/angular';
import { IProperty } from "src/app/interfaces/property.interface";
import { IUser } from "src/app/interfaces/user.interface";
import { PropertyService2 } from "src/app/services/property2.service";
import { UserAdminService } from "src/app/services/user.service";

@Component({
	selector: 'admin-user-details-modal',
	templateUrl: './admin-user-details-modal.html',
	styleUrls: ['./admin-user-details-modal.scss'],
})
export class AdminUserDetailsModal implements OnInit {
	user: IUser
	properties: IProperty[]
	loading = true

	constructor(
		public viewCtrl: ModalController,
		public params: NavParams,
		public toastCtl: ToastController,
		public userService: UserAdminService,
		public propertyService: PropertyService2,
		public nav: NavController,
	) {
		this.user = this.params.get('user')
	}

	async ngOnInit() {
		await this.load()
	}

	async load() {
		this.loading = true
		try {
			// TODO: load all the properties for this user
			this.properties = await this.propertyService.adminPropertySearch({ userId: this.user._id }).then(({ properties }) => properties)
		} catch (e) {
			console.error(`Error loading user properties`)
			const toast = await this.toastCtl.create({message: 'Error loading user properties', duration: 3000, position: 'top'})
			await toast.present()
		}
		this.loading = false
	}

	close() {
		this.viewCtrl.dismiss()
	}

	routeToPropertyDetails(property: IProperty) {
		this.nav.navigateForward(`/property/${property._id}?userid=${this.user._id}`)
		this.close()
	}
}
